import pick from 'lodash/fp/pick';
import groupBy from 'lodash/fp/groupBy';
import mapValues from 'lodash/fp/mapValues';
import {connect} from 'react-redux';
import {getStatus, getResources} from 'redux-resource';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import mapProps from 'recompose/mapProps';
import withState from 'recompose/withState';
import withHandlers from 'recompose/withHandlers';
import {readCollections, deleteCollection} from '../../../../redux/actions/collections';
import {readAllFiles} from '../../../../redux/actions/files';
import {setLanguage} from '../../../../redux/actions/languages';
import withLoadingIndicator from '../../../common/with-loading-indicator';
import List from './list';

const aggregateFilesByCollection = compose(
	mapValues('length'),
	groupBy('collection'),
);

function mapStateToProps(state) {
	const status = getStatus(state, [
		'collections.requests.all.status',
		'files.requests.all.status'
	]);
	const items = getResources(state.collections, 'all');
	const filesCount = aggregateFilesByCollection(getResources(state.files, 'all'));
	const languages = getResources(state.languages, 'all');
	const currentLanguage = state.languages.switchValue;

	return {
		status,
		items,
		filesCount,
		languages,
		currentLanguage
	};
}

function mapDispatchToProps(dispatch, props) {
	return {
		readList: () => {
			dispatch(readCollections());
			dispatch(readAllFiles());
		},
		handleShowFiles: id => {
			props.history.push(`/admin/collections/${id}/files`);
		},
		handleEditItem: id => {
			props.history.push(`/admin/collections/${id}`);
		},
		deleteItem: id => {
			dispatch(deleteCollection(id));
		},
		setLanguage: lang => {
			dispatch(setLanguage(lang));
		}
	};
}

const enhance = compose(
	connect(mapStateToProps, mapDispatchToProps),
	lifecycle({
		componentDidMount() {
			this.props.readList();
		}
	}),
	withLoadingIndicator,
	withState('deleteTarget', 'setDeleteTarget', {}),
	withState('deletionWarning', 'setDeletionWarning', false),
	/* Do not replace deleteConfirmation with isUndefined check of deletTarget
	 * in open prop of DeleteDialog!
	 * reason: fields of deleteTarget are used in render of
	 * delete confirmation dialog. */
	withState('deleteConfirmation', 'setDeleteConfirmation', false),
	withHandlers({
		handleSelectLanguage: props => event => {
			props.setLanguage(event.target.value);
		},
		handleDeleteItem: props => (id, name, filesCount) => {
			if (filesCount !== 0) {
				props.setDeletionWarning(true);
			} else {
				props.setDeleteTarget({id, name, type: 'collection'});
				props.setDeleteConfirmation(true);
			}
		},
		handleCancelDelete: props => () => {
			props.setDeleteConfirmation(false);
		},
		handleConfirmDelete: props => () => {
			props.setDeleteConfirmation(false);
			props.deleteItem(props.deleteTarget.id);
		},
		closeDeletionWarning: props => () => {
			props.setDeletionWarning(false);
		}
	}),
	mapProps(pick([
		'items',
		'filesCount',
		'handleShowFiles',
		'handleEditItem',
		'handleDeleteItem',
		'handleSelectLanguage',
		'handleConfirmDelete',
		'handleCancelDelete',
		'deleteTarget',
		'deleteConfirmation',
		'deletionWarning',
		'closeDeletionWarning',
		'languages',
		'currentLanguage'
	]))
);

export default enhance(List);



// WEBPACK FOOTER //
// ./src/client/components/admin/collections/list/index.js